import { render, staticRenderFns } from "./HouseFundAdmFee.vue?vue&type=template&id=42883f09&"
import script from "./HouseFundAdmFee.vue?vue&type=script&lang=js&"
export * from "./HouseFundAdmFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports